var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentMethodCcHold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 7.25C2.5286 7.25 2.41667 7.36193 2.41667 7.5C2.41667 7.63807 2.5286 7.75 2.66667 7.75V7.25ZM4.61111 7.75C4.74918 7.75 4.86111 7.63807 4.86111 7.5C4.86111 7.36193 4.74918 7.25 4.61111 7.25V7.75ZM2.11111 3.25H9.88889V2.75H2.11111V3.25ZM10.75 4V8H11.25V4H10.75ZM9.88889 8.75H2.11111V9.25H9.88889V8.75ZM1.25 8V4H0.75V8H1.25ZM2.11111 8.75C1.6101 8.75 1.25 8.39009 1.25 8H0.75C0.75 8.71448 1.38482 9.25 2.11111 9.25V8.75ZM10.75 8C10.75 8.39009 10.3899 8.75 9.88889 8.75V9.25C10.6152 9.25 11.25 8.71448 11.25 8H10.75ZM9.88889 3.25C10.3899 3.25 10.75 3.60991 10.75 4H11.25C11.25 3.28552 10.6152 2.75 9.88889 2.75V3.25ZM2.11111 2.75C1.38482 2.75 0.75 3.28552 0.75 4H1.25C1.25 3.60991 1.6101 3.25 2.11111 3.25V2.75ZM1 5.25H11V4.75H1V5.25ZM2.66667 7.75H4.61111V7.25H2.66667V7.75Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodCcHold);
export default __webpack_public_path__ + "static/media/payment-method-cc-hold.1983433e.svg";
export { ForwardRef as ReactComponent };